import { CandidateProfileContent } from '@/features/recruitment/components/candidate-profile-content';
import { useCandidate } from '@/hooks/use-candidates';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/recruitment/candidates_/$id/profile')({
  component: ProfileTab,
});

function ProfileTab() {
  const { id } = Route.useParams();
  const { data, isLoading, error } = useCandidate(id);

  if (isLoading) {
    return (
      <div className="rounded-lg border border-border bg-background p-6 text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="rounded-md border border-destructive/40 bg-destructive/10 p-4 text-sm text-destructive">
        Failed to load candidate.
      </div>
    );
  }

  return <CandidateProfileContent candidate={data} />;
}
